export default __webpack_public_path__ + "static/media/img-0245-australia-premium-face.8da72709.png";